import { useEffect, useState } from 'react';

const LINKS = [
  ['vision', 'Vision'], ['education', 'Education'], ['journey', 'Student Journey'], ['campus', 'Campus'],
  ['qualification', 'Qualification'], ['model', 'Hub Model'],
  ['originals', 'UPA Originals'], ['industry', 'Industry'], ['growth', 'Growth'], ['partnerships', 'Partnerships'],
];

export const CollegeNav = ({ active }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const h = document.documentElement;
        const max = h.scrollHeight - h.clientHeight;
        setProgress(max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0);
        raf = null;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener('scroll', onScroll); if (raf) cancelAnimationFrame(raf); };
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <nav aria-label="Presentation sections" className="fixed top-0 inset-x-0 z-50" data-testid="college-nav">
    <div className="h-[3px] bg-white/10">
      <div className="h-full" style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #FF007F, #7000FF, #FFD700)', willChange: 'width' }} data-testid="college-progress" />
    </div>
      <div className="backdrop-blur-xl bg-[#050505]/80 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto flex items-center gap-2 px-4 sm:px-8 py-2 overflow-x-auto scrollbar-none">
          <span className="font-heading text-white text-sm mr-2 whitespace-nowrap hidden sm:block">UPA <span className="text-[#FFD700]">College</span></span>
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`college-nav-${id}`}
              className={`whitespace-nowrap shrink-0 text-xs sm:text-sm px-3 py-1.5 rounded-full transition-colors ${active === id ? 'text-white bg-white/10 font-semibold' : 'text-white/50 hover:text-white'}`}
              style={active === id ? { boxShadow: 'inset 0 0 0 1px rgba(255,0,127,0.5)' } : undefined}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};
